import React from "react";
import { validateForm } from "utils/validation";
import { PoolTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPoolTypeForm from "./Components/AddPoolTypeForm";
import Fields from "../json/PoolTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { createPoolType } from "adminApi/PoolTypeApi/PoolType";


const AddPoolType = ({ setRefetch, refetch }) => {
    const { formdata } = Fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        PoolTypeRules
    );

    // Form submit handler
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await createPoolType({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, PoolTypeRules);
            setErrors(err);
            return err;
        },
        () => {
            // Reset form and trigger table refetch
            setValues(initialValues);
            setRefetch(!refetch);
        },
        "Pool Type created successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddPoolTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Add Pool Type"
            />
        </>
    );
};

export default AddPoolType;
